module.exports = __webpack_public_path__ + "img/ab-bottom.63a9a95e.png";